<template>
	<div class="modal animated fadeIn" id="login-form" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-close-container">
			<button id="close" onclick="document.getElementById('login-form').style.display='none';" type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header text-center">
					<h4 class="modal-title w-100">Prijavite se</h4>
				</div>
				<div class="modal-body">
					<div class="input-group mb-3">
						<!-- <button id="submit" name="submit" type="submit" class="fs-btn fb text-uppercase btn-lg btn-block">Prijavi se preko facebooka</button> -->
						<!-- <facebook-login class="button"
                        appId="606396993332867"
                        @login="getUserData"
                        @logout="onLogout" 
                        @sdk-loaded="sdkLoaded"
                        >
                        </facebook-login> -->
					</div>
					<form @submit="login($event)" class="text-center mb-5">
						<div class="input-group mb-3">
							<!-- <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"><i class="fa fa-user fa-1x"></i></span>
                        </div> -->
							<input id="name" v-model="user.email" type="text" class="form-control" placeholder="E-adresa ili korisničko ime" aria-label="name" aria-describedby="basic-addon1">
						</div>
						<div class="input-group mb-3">
							<!-- <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon2"><i class="fa fa-key fa-1x"></i></span>
                        </div> -->
							<input id="password" v-model="user.password" type="password" class="form-control" placeholder="Lozinka" aria-label="password" aria-describedby="basic-addon2">
						</div>
						<notify></notify>
						<button id="submit" name="submit" type="submit" class="fs-btn primary text-uppercase btn-lg"><loaderCircle v-if="loader"></loaderCircle>
							<span v-else> Prijavite se </span>
						</button>
						<div class="input-group mt-3">
						</div>
					</form>
					<p class="modal-text text-center">Nemate korisnički račun? <a href="#" onclick="document.getElementById('login-form').style.display='none';" data-dismiss="modal" data-toggle="modal" data-target="#register-form">Registrirajte se!</a></p>
					<p class="text-center"><a href="#" data-dismiss="modal" data-toggle="modal" data-target="#password-form1">Zaboravili ste lozinku?</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		name: 'loginModal',
		data: () => {
			return {
				user: {
					email: '',
					password: '',
				},
				FB: undefined,
				closeForm: false,
				loader: false,
				result: null
			}
		},
		computed: {
			...mapState({
				endpoint: (state) => state.endpoint,
				notification: (state) => state.notification,
			}),
		},
		methods: {
			...mapMutations({
				setNotif: 'setNotification',
				setLoader: 'setLoader',
				handleError: 'handleError',
				setUser: "setUser"
			}),
			sdkLoaded(payload) {
				console.log(payload);
				this.FB = payload.FB;
				console.log('loaded');
			},
			getUserData(data) {
				console.log(data);

				this.FB.api('/me', 'GET', {
						fields: 'id,name,email,picture'
					},
					user => {
						this.result = user;
					});
				console.log(this.result);
			},
			onLogout() {},
			login(e) {
				e.preventDefault();

				for (var item in this.user) {
					if (this.user[item].length == 0) {
						this.setNotif({
							type: 2,
							msg: "Sva polja su obavezna!"
						});
						return false;
					}
				}
				this.loader = true;
				this.$store.dispatch('post', {
						details: this.user,
						endpoint: this.endpoint + 'login'
					})
					.then((data) => {
						console.log(data);
						if (data.data.token != null) {
							this.setUser(data.data);
							window.$("#close").click();
							/*
                    if(data.data.user.vendor == null){
                        if(this.$route.path == '/'){
                            // window.location.href='/user#postavke';
                            window.location.reload();
                        }else{
                            // window.location.href='/user#postavke';
                        }
                    }else{
                        
                        window.location.href='/';
                    }
									*/
						} else {
							this.setNotif({
								type: 2,
								msg: data.data.message
							});
						}
						this.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						if (error.request != null) {
							this.$store.dispatch("handleError", error);
						}
						this.loader = false;
					});
			},

		},
		created() {

		}
	}

</script>
<style>

.modal-text {
	font-size: 1rem !important;
	font-weight: 200;
}

</style>